import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import EditAlbum from '../components/EditAlbum';
import Album from '../models/Album';

const translationPrefix = 'kilowhat-cimaise.forum.edit-album-modal.';

interface EditAlbumModalAttrs extends IInternalModalAttrs {
    album: Album
    ondelete: () => void
}

export default class EditAlbumModal extends Modal<EditAlbumModalAttrs> {
    className() {
        return 'Modal--small';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title', {
            title: this.attrs.album.title(),
        });
    }

    content() {
        return m('.Modal-body', m(EditAlbum, {
            album: this.attrs.album,
            ondelete: () => {
                this.hide();
                this.attrs.ondelete();
            },
        }));
    }
}
